jQuery(document).ready(function ($) {
    

    /*----------------------------------------------------------------GLOBAL ON LOAD----*/

	var lazyLoadInstance = new LazyLoad();
	
    lazyLoadImages();
	
	AOS.init({disable: 'mobile'});
    
    $('.ham-btn').click(function(){
        $(this).toggleClass('active');
        $('body').toggleClass('noScroll');
        $('header nav.global').slideToggle();
    });
    
//    var parallaxImages = document.querySelectorAll('parallaxImage');
//    console.log(parallaxImages);
//    var prallax = new simpleParallax(parallaxImages);
    
    $('header.global a .more-less').click(function(e){
        e.preventDefault();
        $this = $(this).parent().parent();
        $this.find('.dropdown-menu').slideToggle();
    });
    
    $('.accordion__trigger').click(function () {
        var $this = $(this);
        $this.toggleClass('active');
        $this.next().slideToggle();
    });
    
    $('footer a.heading').click(function(e){
        if( $(window).width() < 960 ){
            e.preventDefault();
            $(this).toggleClass('active');
            $(this).next().slideToggle();
        }
    });
    
    $('.post-filter').on('click', 'li a', function (e) {
        e.preventDefault();
        $('.post-filter a.active').removeClass('active');
        $(this).addClass('active');
        var target = $(this).attr('href');
        ajaxLoadPosts(target);
    });
    
    $('.posts-block').on('click', '.wp-pagenavi a', function (e) {
        e.preventDefault();
        var target = $(this).attr('href');
        ajaxLoadPosts(target);
    });
	
	var staffPageFilters = (function () {
		var $filters = $('.post-filter--staff button');
		$filters.click(function(e){
			e.preventDefault();
			$('.post-filter--staff button.active').removeClass('active');
			$(this).addClass('active');
			var target = $(this).data('target');
			$('.archive-block').hide();
			$('.archive-block.'+target).show();
			$('.full-width-gallery .gallery').slick('refresh');
		});
	}());
    
    $('#open-chat').click(function(){
		$('[data-test-id="ChatWidgetWindow"]').addClass('show');
        $zopim.livechat.window.show();
        console.log('clicked chat open');
    });
    
    function ajaxLoadPosts(target){
        $('.posts-block').addClass('loading');
        $('html, body').animate({
            scrollTop: $('.posts-block').offset().top + $('header.global').height() - 64
        }, 1000);
        $.ajax({
            type: 'GET',
            dataType: 'html',
            url: target,
            success: function (response) {
//                console.log(response);
//                console.log($(response));
                var title = $(response).filter('title').text();
                response = $(response).find('.posts-block').html();
                $('.posts-block').html(response);
                lazyLoadImages();
                setTimeout(function () {
                    var linkUrl = target;
					ajaxTitles(linkUrl,title);
                    $('.posts-block').removeClass('loading');
                }, 250);
            }
        });
        
    }
    
    function ajaxTitles(linkUrl,title){
        document.title = title;
        window.history.pushState("", title, linkUrl);
//        console.log(linkUrl);
//        ga('set', 'page', linkUrl);
//        ga('send', 'pageview');
    };
    
    function hidePDMlightbox(){
        $('.pdm-lightbox').fadeOut();
        $('body').removeClass('no-scroll');
        $('.pdm-lightbox__close').hide();
       /* if( empty == true ){*/
            $('.pdm-lightbox:not(.dont-empty) .pdm-lightbox__popup').empty();
            $('.pdm-lightbox:not(.dont-empty)').attr('class', 'pdm-lightbox');
        /*}*/
    }

    $('.pdm-lightbox').on('click', '.pdm-lightbox__close', function (e) {
        /*if( $(this).closest('.pdm-lightbox').hasClass('dont-empty') ){
            hidePDMlightbox(false);
        }else{
             hidePDMlightbox(true);
        }*/
        hidePDMlightbox();
    });


    $('.pdm-lightbox').on('click', function (e) {
        if (e.target == this) {
          /*  if( $(this).hasClass('dont-empty') ){
                hidePDMlightbox(false);
            }else{
                hidePDMlightbox(true);
            }
            */ 
            hidePDMlightbox();

        }
    });

    $('.contact-popup').click(function (e) {
        e.preventDefault();
        $('body').addClass('no-scroll');
        $('.pdm-lightbox__close').show();
        $('.pdm-lightbox--form').css('display', 'flex').hide().fadeIn();
    });

    $('.modal__trigger').click(function (e) {
        e.preventDefault();
        var $this = $(this),
            content,
            target,
            classes;
        classes = $(this).data('classes');
		
        if( $this.data('target') ){
            target = $this.data('target'),
            content = $(target).html();
        }else{
            content = $this.next('.modal--content').html();
        }

        $('.pdm-lightbox:not(.pdm-lightbox--form) .pdm-lightbox__popup').append(content);
        $('body').addClass('no-scroll');
		
        $('.pdm-lightbox:not(.pdm-lightbox--form)').addClass(classes);
        $('.pdm-lightbox:not(.pdm-lightbox--form) .pdm-lightbox__close').show();
        
        var video = $('.pdm-lightbox iframe').data('src');
        $('.pdm-lightbox:not(.pdm-lightbox--form) iframe').attr('src', video);
        
        $('.pdm-lightbox:not(.pdm-lightbox--form)').css('display', 'flex').hide().fadeIn();
    }); /*end modal function*/


    //REFACTOR
    $('.the-testimonials').on('click', '.modal__trigger--testimonial', function(e) {
        e.preventDefault();
        var classes = $(this).data('classes');
        var content = $(this).next('.modal--content').html();
        $('body').addClass('no-scroll');
        $('.pdm-lightbox:not(.pdm-lightbox--form) .pdm-lightbox__popup').append(content);
        $('.pdm-lightbox:not(.pdm-lightbox--form)').addClass(classes);
        $('.pdm-lightbox:not(.pdm-lightbox--form) .pdm-lightbox__close').show();
        var video = $('.pdm-lightbox:not(.pdm-lightbox--form) iframe').data('src');
        $('.pdm-lightbox:not(.pdm-lightbox--form) iframe').attr('src', video);
        $('.pdm-lightbox:not(.pdm-lightbox--form)').css('display', 'flex').hide().fadeIn();

    });


    if ($('.slowlax').length) {
        setInterval(function () {
            $('.slowlax').each(function () {
                var offset = 0;
                if ($(this).data('offset') != undefined) {
                    offset = $(this).data('offset');
                }
                var offsetTop = $(this).closest('section').offset().top - offset;
                var scrollTop = $(window).scrollTop();
                if (scrollTop > offsetTop) {
                    scrollTop = scrollTop - offsetTop;
                    var percent = scrollTop / 3 + 'px';
                    var opacity = 1 - scrollTop / 600;
                    if ($(this).hasClass('fade')) {
                        $(this).css({
                            transform: 'translateY(' + percent + ')',
                            opacity: opacity,
                            'transition-duration': '0s'
                        });
                    } else {
                        $(this).css({
                            transform: 'translateY(' + percent + ')',
                            'transition-duration': '0s'
                        });
                    }
                }
            });

        }, 15);
    };

    
    $('.disease-filters__options button.active').click(function(){
        var target = $(this).data('target');
        $('.disease-filters__options button').removeClass('current');
        $(this).addClass('current');
        $('.disease-filters__results a').removeClass('active');
        $('.starts-w-'+target).addClass('active');
    });

    //check what image from the array is best and change the image src to it
    function changeBgImgSrc(container, srcset) {
        var wWidth = $(window).width();
        if (window.devicePixelRatio >= 2) {
            //            wWidth = wWidth * 2;
        }
        $.each(srcset, function (index, i) {
            //if the next one does exist use the biggest one
            if (srcset[index + 1] == undefined) {
                container.css({
                    'background-image': 'url(' + srcset[srcset.length - 1].url + ')'
                });
            } else {
                //if the current items width is smaller than the screen size and the width of the next item is bigger than the screen size use the current item.
                if (i.width > wWidth) {
                    container.css({
                        'background-image': 'url(' + i.url + ')'
                    });
                    return false;
                }
            }
        });
    }

    //grab the image srcet place in array and send it to changeBfImgSrc to check what image is best
    function resBGImages($resimgs) {
        $resimgs.each(function () {
            var container = $(this)
            var sources = $(this).data('src-set');
            var groups = sources.split(',');
            var srcset = [];
            $.each(groups, function (index, i) {
                var current = this.trim().split(' ');
                srcset.push({
                    width: parseInt(current[1].replace('w', ''), 10),
                    url: current[0]
                });
            });

            function compareWidth(a, b) {
                if (a.width < b.width)
                    return -1;
                if (a.width > b.width)
                    return 1;
                return 0;
            }
            srcset.sort(compareWidth);
            changeBgImgSrc(container, srcset)
        });
    };

    //run this function when the screen is done resizing
    var resizeId;
    $(window).resize(function () {
        clearTimeout(resizeId);
        resizeId = setTimeout(doneResizing, 500);
    });

    var screenW = $(window).width();

    function doneResizing() {
        var newScreenW = $(window).width();
        //only run if the screen size is larger than it was before
        if (screenW <= newScreenW) {
            var $resimgs = $(':not(.static)[data-src-set]');
            resBGImages($resimgs);
            screenW = newScreenW;
        }
    }


    //----------------------------------------------
    //* Slick Sliders
    //---------------------------------------------


     var twoColumnGallery = (function () {
        var $slider = $('.two-column__slider');
            $slider.slick({
                mobileFirst: true,
                slidesToShow: 1,
                infinite: true,
                arrows: true,
                draggable: false,
                fade: true,
                prevArrow: $('.two-column--gallery button.prev'),
                nextArrow: $('.two-column--gallery button.next')
            });
        
    }());


    /* var recentPosts = (function () {
        var $slider = $('.post-slider');
            $slider.slick({
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                arrows: true,              
                appendArrows: $(".blog-recent .slick-nav"),
                draggable: false,
                  responsive: [

                   {
                            breakpoint: 960,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1

                            }
                        },               

                        {
                            breakpoint: 1200,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 1

                            }
                        }
                    ]        

            });
    }()); */

    var staffSlider = (function () {
        var $slider = $('.staff-slider');
            $slider.each(function(){
                $(this).slick({
                    mobileFirst: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    arrows: true,              
                    appendArrows: $(this).next(".slick-nav"),
                    draggable: false,
                      responsive: [

                       {
                                breakpoint: 960,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 1

                                }
                            },               

                            {
                                breakpoint: 1200,
                                settings: {
                                    slidesToShow: 3,
                                    slidesToScroll: 1

                                }
                            }
                        ]        

                });
            });
    }());  
    


    var gallery = (function () {
		
        $('.full-width-gallery .gallery').slick({
            mobileFirst:true,
            arrows:true,
            dots:false,
            prevArrow: $('.full-width-gallery button.prev'),
            nextArrow: $('.full-width-gallery button.next'),
            asNavFor: $('.full-width-gallery .gallery-nav'),
            responsive: [
                {
                    breakpoint: 960,
                    settings: {                      
                        draggable: false,
                    },
                }
            ]
        });
        
        $('.full-width-gallery .gallery-nav').slick({
            arrows:false,
            draggable: false,
            dots:false,
            slidesToShow: 7,
            rtl: true,
            asNavFor: $('.full-width-gallery .gallery'),
        });
        
         $('.full-width-gallery .gallery-nav .slick-slide').click(function(e) {
            e.preventDefault();
            var slideno = $(this).data('slick-index');
            console.log('go to ' + slideno);
            $('.full-width-gallery .gallery').slick('slickGoTo', slideno );
         });
        
    }());
    
    $('.two-col-gallery .gallery').slick({
        mobileFirst:true,
        arrows:false,
        dots:true,
        infinite:false,
        prevArrow: $('.two-col-gallery button.prev'),
        nextArrow: $('.two-col-gallery button.next'),
        responsive: [
            {
                breakpoint: 960,
                settings: {
                    dots:false,
                    arrows:true,
                    slidesToShow: 2,
                },
            }
        ]
    });

    var testimonials = (function () {
        var $slider = $('.testimonials__slider');
        $slider.each(function() { 
            $(this).slick({
                mobileFirst: true,
                slidesToShow: 1,
                infinite: true,
                arrows: true,
                appendArrows: $(this).next(".slick-nav"),
                dots: false,
                responsive: [

                        {
                            breakpoint: 1450,
                            settings: {
                                centerMode: true,

                            }
                        }
                    ]        

            });
        });
    }());
    
    
    $('.list-as-search-select input').keyup(function () {
        var $this = $(this);
        var input = $this.val();
        var length = input.length;
        input = input.toLowerCase();
        
        console.log('input = ' + input);
                
        $this.parent().find('ul li').removeClass('hide');
        $this.parent().find('ul li').removeClass('first');
        $this.parent().find('ul li').addClass('hide');
        
        $this.parent().find('ul li').each(function () {
            var $that = $(this);
            var tags = $that.data('tags');
            tags = tags.split(',');
            var count = 0;
            $.each(tags, function (index, tag) {
                count++;
                tag = tag.toLowerCase();
                if (tag.includes(input)) {
//                    console.log('found ' + tag);
                    $that.removeClass('hide');
                    tag = tag.substring(0, length);
                    if (tag == input && count == 1) {
                        $that.addClass('first');
                    }
                }
            });
        });
        
        
        var found = $this.parent().find('ul li:not(.hide)').length
        if( found == 0 ){
            $this.parent().find('ul').append('<li data-tags="" class="no">No matches</li>');
        }else{
            $this.parent().find('ul li.no').remove();
        }
        
    });
    
    $('.the-therapies .decease-filters a').click(function(e){
        e.preventDefault();
        var target = $(this).parent().data('id');
        var text = $(this).text();
        $('.list-as-search-select input').attr("placeholder", text);
        $('.therapies-list__item').hide();
		
		//start temporary code
		if( target == 73 ){
        	$('.therapies-list__item').css({ display: 'flex' });
		}else{
        	$('.treat-'+target).css({ display: 'flex' });
		}
		//end temporary
		
//        $('.treat-'+target).css({ display: 'flex' });
		
        $('.list-as-search-select ul').hide();
    });
    
    
    $('.decease-filters input, .faqs-filters__select input, .testimonial-filters-list input, .blog-categories input').focus(function(){
        $('.list-as-select ul').css("display","");
        $('.list-as-search-select ul').css("display","");
    });
    
    
    $('.faqs-filters__select li').click(function(){
        var val = $(this).text();
        $('.faqs-filters__select li.active').removeClass('active');
        $(this).addClass('active');
        var target = $(this).data('target');
        $('.faqs-filters__select ul').hide();
        $('.faqs-filters__select input').val(val);
        $('.faq-section-block').hide();
        $('.'+target).show();
    });
    
    $('.testimonial-filters-list li').click(function(){
        var val = $(this).text();
        $('.testimonial-filters-list li.active').removeClass('active');
        $(this).addClass('active');
        var target = $(this).data('target');
        $('.testimonial-filters-list ul').hide();
        $('.testimonial-filters-list input').val(val);
        if( $(window).width() < 1200 ){
            $('.the-testimonials').addClass('loading');
            ajaxTestimonials(target, true);
        }
    });
    
    $('.testimonial-filters .submit').click(function(e){
        
        e.preventDefault();
        
        var $that = $('.testimonial-filters-list li.active');
        
        var val = $that.text();
        $('.testimonial-filters-list li.active').removeClass('active');
        $that.addClass('active');
        var target = $that.data('target');
        $('.testimonial-filters-list ul').hide();
        $('.testimonial-filters-list input').val(val);
        $('.the-testimonials').addClass('loading');
        ajaxTestimonials(target, true);
        
    });
    
    $('.the-testimonials').on('click', '.load-more-btn a', function(e){
        e.preventDefault();
        $(this).addClass('loading');
        var target = $(this).attr('href');
        ajaxTestimonials(target, false);
        
    });
    
    function ajaxTestimonials( target, replace ){
        $.ajax({
            type: 'GET',
            dataType: 'html',
            url: target,
            success: function (response) {
//                console.log(response);
                if( replace == true ){
                    $('.the-testimonials').html($(response).find('.the-testimonials').html());
                }else{
                    $('.loading-animation').before($(response).find('.the-testimonials article'));
                }
                if( $(response).find('.load-more-btn').length ){
                    if( $('.load-more-btn').length ){
                        $('.load-more-btn').html( $(response).find('.load-more-btn').html() );
                    }else{
                        $('.the-testimonials').append( $(response).find('.load-more-btn') );
                    }
                }else{
                    if( $('.load-more-btn').length ){
                        $('.load-more-btn').remove();
                    } 
                }
                lazyLoadImages();
                setTimeout(function () {
                    $('.the-testimonials').removeClass('loading');
                    lazyLoadImages();
                },250);
            }
        });
    }
    
    $('.content_slider_with_icon_nav .slider-steps button').click(function(e){
        
        e.preventDefault();
    
        $('.content_slider_with_icon_nav .slider-steps li.active').removeClass('active');
        var selectedNum = parseInt($(this).data('index'));

        for( var i = 1; i <= selectedNum; i++ ){
            $('.content_slider_with_icon_nav .slider-steps button[data-index="'+i+'"]').parent().addClass('active');
        }
        
        $('.two-column__slider').slick('slickGoTo', selectedNum-1 );
        
    });
    
    if( $('.content_slider_with_icon_nav').length ){
        $('.two-column__slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
            
            $('.content_slider_with_icon_nav .slider-steps li.active').removeClass('active');
            var selectedNum = currentSlide+1;
            for( var i = 1; i <= selectedNum; i++ ){
                $('.content_slider_with_icon_nav .slider-steps button[data-index="'+i+'"]').parent().addClass('active');
            }
            
        });
    }


	var smoothScroll = (function () {
        $('a[href^="#"]').on('click', function (e) {
            e.preventDefault();

            var target = this.hash;
            var $target = $(target);

            $('html, body').stop().animate({
                'scrollTop': $target.offset().top
            }, 1200, 'swing', function () {
                window.location.hash = target;
            });
        });
    }());
	
	var urlParams = (function (strParam) {
		// get url parameters
		var arrURLParams = window.location.search.replace('?', '').split('&');
		// obj placeholder for params
		var objParams = {};
		// convert parameters into an object
		arrURLParams.map(function (val) {
			var arrPair = val.split('=');
			objParams[arrPair[0]] = decodeURIComponent(arrPair[1]);
		});
		return {
			get: function (strParam) { return objParams[strParam]; }
		}
	}());

//	var formVariables = (function(){
//		var keywords = urlParams.get('gclid');
//		console.log(keywords);
//		$('.form-lightbox [name="input_30"]').val(keywords);
//	}());

});

//Load Images on Doc Ready
function lazyLoadImages() {
    var lazyImages = jQuery('img[data-src]:not(.lazy), [data-background]');
    lazyImages.each(function () {
        var $this = jQuery(this),
            src,
            dataSrc;
        if (!$this.data('src-set')) {
            if (dataSrc = $this.data('background')) {
                var delay = 0;
                if ($this.data('background-delay')) {
                    delay = $this.data('background-delay');
                }
                setTimeout(function () {
                    $this.css('background-image', 'url(' + dataSrc + ')');
                    $this.attr('data-background', null);
                }, delay);
            } else if (dataSrc = $this.data('src')) {
                $this.attr('src', $this.data('src'));
                $this.attr('data-src', null);
            }
        }
    });
	setTimeout(function(){
		AOS.refresh();
//		AOS.init({disable: 'mobile'});
	},250);
}

